import { render, staticRenderFns } from "./lahi-error.vue?vue&type=template&id=60248d2d&lang=pug"
import script from "./lahi-error.vue?vue&type=script&lang=js"
export * from "./lahi-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports